/** Shared/common API types. */

export interface PagedResponse<T> {
  items: T[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface ApiError {
  status: number;
  message: string;
  details?: string[];
  /**
   * True when the request failed because the Auth0 session can no longer be
   * silently renewed. The API client has already started a redirect to login,
   * so callers should avoid showing an additional error toast.
   */
  sessionExpired?: boolean;
}

export interface PaginationParams {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  search?: string;
}

/**
 * Communication channel (TECH-626). Mirrors the backend `CommunicationChannels`
 * constants: `email` = tracked emails, `sms` = SMS/MMS text messages.
 */
export type Channel = 'email' | 'sms';

export const CHANNELS: readonly Channel[] = ['email', 'sms'];

/** Global filter parameters passed to most dashboard/report endpoints. */
export interface GlobalFilterParams {
  brandIds?: number[];
  businessUnitIds?: number[];
  regionIds?: number[];
  competitorBrandIds?: number[];
  dateFrom?: string; // ISO yyyy-MM-dd (inclusive)
  dateTo?: string; // ISO yyyy-MM-dd (inclusive)
  /** Restrict a report to one channel; omitted = emails and text messages combined. */
  channel?: Channel;
}

export type TrendDirection = 'up' | 'down' | 'flat';

export interface TrendPoint {
  date: string;
  value: number;
}
